import { Restaurant } from '@/typings/entity/restaurant';

export function headerImageUrl(restaurant: Restaurant) {
  return `/images/brands/${restaurant.brandId}.jpg`;
}
